<ng-container #outlet [ngTemplateOutlet]="wrapper"></ng-container>

<ng-template #wrapper>
  @if (mode === 'context') {
    <div class="context-wrapper" [cdkContextMenuTriggerFor]="menu" [cdkContextMenuTriggerData]="{ items: items }">
      <ng-container *ngTemplateOutlet="content" />
    </div>
  } @else {
    <button class="flex" [cdkMenuTriggerFor]="menu" [cdkMenuTriggerData]="{ items: items }">
      <ng-container *ngTemplateOutlet="content" />

      <ts-icon
        *ngIf="!(hasCustomTrigger | async)"
        icon="more_vert"
        class="text-cool-gray-500 scale-110 default-menu-trigger"
      ></ts-icon>
    </button>
  }
</ng-template>

<ng-template #content><ng-content></ng-content></ng-template>

<ng-template #menu let-items="items">
  <div
    cdkMenu
    (keydown.arrowUp)="onArrowUpOrDown()"
    (keydown.arrowDown)="onArrowUpOrDown()"
    (mouseover)="onMouseOver()"
    class="shadow-md menu-wrapper"
  >
    <div class="flex flex-col justify-start items-start py-1 bg-white rounded border min-w-48 max-w-96">
      @for (item of items; track item.label) {
        @if (item?.children) {
          <div
            cdkMenuItem
            [cdkMenuTriggerFor]="menu"
            [cdkMenuTriggerData]="{ items: item.children }"
            [attr.data-testid]="item.dataTestId"
            class="w-full focus:bg-cool-gray-200"
          >
            <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
          </div>
        } @else {
          <div cdkMenuItem class="w-full focus:bg-cool-gray-200" (cdkMenuItemTriggered)="triggerAction(item)" [attr.data-testid]="item.dataTestId">
            <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
          </div>
        }
      }
    </div>
  </div>
</ng-template>

<ng-template #menuItem let-item>
  <button
    tabindex="0"
    [disabled]="item.disabled && item?.disabled()"
    class="px-2 py-1 w-full menu-item hover:bg-cool-gray-100"
    [attr.data-testid]="item.dataTestId"
  >
    <div class="flex flex-row gap-1 justify-between">
      <div class="flex flex-row gap-2 justify-start items-center w-full">
        <ts-icon
          *ngIf="item?.icon"
          [icon]="item.icon"
          [color]="getIconColor(item?.variant)"
          [outlined]="item?.outlined"
          class="text-cool-gray-500 w-fit-content"
        ></ts-icon>
        <span class="truncate max-w-72" [ngClass]="item?.variant && 'text-' + item.variant">{{ item.label }}</span>
      </div>
      <ts-icon
        *ngIf="item.children && item.children.length > 0"
        icon="chevron_right"
        [outlined]="item?.outlined"
        class="text-cool-gray-500"
      ></ts-icon>
    </div>
  </button>
</ng-template>
